<!--
 * @Description: 师傅未保价-倒计时
 * @Autor: xza
 * @Date: 2022-07-22 10:07:30
 * @LastEditors: xza
 * @LastEditTime: 2022-07-22 16:00:45
-->
<template>
<div class="Etime">
  <!-- <div>
    <img class="Etime-icon" src="../../assets/images/bao2.png">
  </div> -->
  <div class="Etime-content">{{content}}</div>
  <div enter-class="Etime-times">距离报价截止还剩<span class="Etime-times--highLight">{{hour}}小时{{minute}}分{{second}}秒</span>,请耐心等待</div>
</div>
</template>

<script>

export default {
  name: 'empty-time',
  props: {
    timeRun: {
      type: [String, Number],
      default: 0
    },
    content: {
      type: String,
      default: '目前暂时没有师傅为你提供标价...'
    }

  },
  data () {
    return {
      hour: '',
      minute: '',
      second: ''
    }
  },
  created () {
    let a = new Date().getTime()
    let nowDate = a.toString().split('').slice(0, 10)
    let nowDateL = nowDate.join().replace(/,/g, '')
    let dates = this.timeRun - Number(nowDateL)
    // console.log('截止时间', this.timeRun)
    // console.log('现在时间', Number(nowDateL))
    this.remainTime = dates
    if (this.remainTime > 0) {
      // 天数
      let day = Math.floor((this.remainTime / 86400))
      // 时
      this.hour = Math.floor(((this.remainTime / 3600) % 24) + (day * 24))
      // 分
      this.minute = Math.floor((this.remainTime / 60) % 60)
      // 秒
      this.second = Math.floor(this.remainTime % 60)
      this.countDowm()
    }
  },

  methods: {
    countDowm () {
      var self = this
      clearInterval(this.timer)
      this.timer = setInterval(function () {
        if (self.hour === 0) {
          if (self.minute !== 0 && self.second === 0) {
            self.second = 59
            self.minute -= 1
          } else if (self.minute === 0 && self.second === 0) {
            self.second = 0
            clearInterval(self.timer)
          } else {
            self.second -= 1
          }
        } else {
          if (self.minute !== 0 && self.second === 0) {
            self.second = 59
            self.minute -= 1
          } else if (self.minute === 0 && self.second === 0) {
            self.hour -= 1
            self.minute = 59
            self.second = 59
          } else {
            self.second -= 1
          }
        }
      }, 1000)
    },
    formatNum (num) {
      return num < 10 ? '0' + num : '' + num
    }
  }
}
</script>
<style lang="scss">
  .Etime{
    text-align: center;
    &-content{
      font-weight: 500;
      color: #191919;
      font-size: 16px;
      margin:10px 0 20px;
    }
    &-icon{
      width: 80px;
      height: 80px;
    }
    &-times{
      font-size: 14px;
      &--highLight{
        color: red;
      }
    }
  }
</style>
